'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var raspberry7 = exports.raspberry7 = '#802636';
var raspberry6 = exports.raspberry6 = '#9D3343';
var raspberry5 = exports.raspberry5 = '#BA3E50';
var raspberry4 = exports.raspberry4 = '#D84C5E';
var raspberry3 = exports.raspberry3 = '#E2636B';
var raspberry2 = exports.raspberry2 = '#EB7878';
var raspberry1 = exports.raspberry1 = '#F48E85';
var raspberry = {
  7: raspberry7,
  6: raspberry6,
  5: raspberry5,
  4: raspberry4,
  3: raspberry3,
  2: raspberry2,
  1: raspberry1
};
exports.default = raspberry;